// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-belmont -> rebel-residential-belmont -> belmont
// Generated: 2026-09-10T20:07:08.492Z
// Counts: 0 design, 14 content, 16 slot group, 0 collection binding, 5 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.pretitle": {
    "overrideType": "VALUE",
    "customValue": "<p><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Layouts</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Be a part of <span data-type=\"field-token\" data-field=\"property_address_city\"></span>'s most exciting luxury apartment community featuring brand new <span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> bedroom floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Create Your Space at <span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodshowcase.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "pinnedcallouts.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Tour Anytime, From Anywhere.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.title": {
    "overrideType": "VALUE",
    "customValue": "<p>We're Here For You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>A Home Design For You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Your Space, Your Home, Your Community</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Ready to upgrade to brand-new living?</strong> Start your online application for The Belmont and choose from studio, one, two, and three-bedroom apartments with pet-friendly spaces, chef-worthy kitchens, in-home washer and dryer, and curated amenities designed for modern convenience.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/pet-friendly-apartments-ladson-sc::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Pet Friendly Apartments in SC</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Resident Access at The Belmont.</strong><br>Convenience is key—pay rent, submit maintenance requests, and manage your account online with ease. Spend less time on to-dos and more time enjoying modern living in your pet-friendly Ladson apartment home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>See luxury living come to life.</strong> Tour brand-new studio, one, two, and three bedroom homes with chef-worthy kitchens, stainless-steel appliances, granite countertops, and in-home washers and dryers. Then get a closer look at the pool, cabanas, fitness center, and clubhouse. Schedule your visit to The Belmont today.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contact-hero.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "View Floor Plans"
      }
    }
  },
  "pinnedcallouts.cta2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Schedule a Tour"
      }
    }
  },
  "propertyoverview.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Choose Your New Home"
      }
    }
  },
  "floorplanslist.card_image_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5c-daab-765a-a582-246291a9dbb4.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern dining and living room with kitchen island, stainless steel appliances, and patio doors."
      }
    }
  },
  "floorplanslist.card_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5c-0492-77fe-97fd-ffa62d094f4c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room and bedroom of a furnished apartment with a couch, chairs, coffee table, and bed."
      }
    }
  },
  "floorplanslist.card_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5c-d408-72bd-af9c-f818d8a15145.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bright and airy living room with a large sofa, accent chairs, coffee table, and a view into a bedroom."
      }
    }
  },
  "floorplanslist.card_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-b685-770a-ab13-f9ec9e093969.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with a sofa, armchair, coffee table, TV, and dining area with a unique wood-based table."
      }
    }
  },
  "floorplanslist.card_image_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5c-d22b-70eb-a655-676cbc75f156.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen with light gray cabinets, granite countertops, stainless steel appliances, and a central island with bar stools."
      }
    }
  },
  "manualfloorplans.plan_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-171a-76ce-bac5-4f52d99b3a62.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Studio floor plan line drawing at The Belmont"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Studio"
      },
      "beds": {
        "type": "GENERATOR",
        "generatedValue": "Studio"
      },
      "baths": {
        "type": "GENERATOR",
        "generatedValue": "1"
      },
      "sqft": {
        "type": "GENERATOR",
        "generatedValue": "603"
      }
    }
  },
  "manualfloorplans.plan_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-2702-701d-9c62-70ac09c74e05.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A4 one-bedroom, one-bath floor plan line drawing at The Belmont"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "A4"
      },
      "beds": {
        "type": "GENERATOR",
        "generatedValue": "1"
      },
      "baths": {
        "type": "GENERATOR",
        "generatedValue": "1"
      },
      "sqft": {
        "type": "GENERATOR",
        "generatedValue": "651"
      }
    }
  },
  "manualfloorplans.plan_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-1ae3-7051-a746-9fe68d29051b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "B1 two-bedroom, two-bath floor plan line drawing at The Belmont"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "B1"
      },
      "beds": {
        "type": "GENERATOR",
        "generatedValue": "2"
      },
      "baths": {
        "type": "GENERATOR",
        "generatedValue": "2"
      },
      "sqft": {
        "type": "GENERATOR",
        "generatedValue": "1,030"
      }
    }
  },
  "manualfloorplans.plan_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-492e-71fe-bcf8-a1177c02db3e.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "C1 three-bedroom, two-bath floor plan line drawing at The Belmont"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "C1"
      },
      "beds": {
        "type": "GENERATOR",
        "generatedValue": "3"
      },
      "baths": {
        "type": "GENERATOR",
        "generatedValue": "2"
      },
      "sqft": {
        "type": "GENERATOR",
        "generatedValue": "1,331"
      }
    }
  },
  "neighborhoodshowcase.photo1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-1764-778b-a4c1-b23d2a9e4602.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Riverfront Park green space and meadow along the Cooper River near The Belmont."
      }
    }
  },
  "neighborhoodshowcase.photo2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-52fe-72a2-9062-d310480eb333.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Ashley River Park with riverside walking trails and playgrounds."
      }
    }
  },
  "neighborhoodshowcase.photo3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-2ce5-7169-af38-40f79ba0c700.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Scenic Azalea Park with landscaped flower beds, ponds, and winding walking trails."
      }
    }
  },
  "neighborhoodshowcase.photo4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e58-eb37-74ef-8231-1e7244613b9c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Charleston Southern University campus near The Belmont apartments."
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0,
      "visible": false
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
